import { selectors as commonSelectors } from '~/domains/common';
import {
  actions as agentScannersActions,
  selectors as agentScannersSelectors
} from '~/domains/agentScanners';
import { isLoggedIn } from '~/utils/validations/profile';

const resolve = async ({ dispatch, getState }) => {
  const state = getState();
  const profile = commonSelectors.profile(state);

  isLoggedIn(profile);

  if (!agentScannersSelectors.isAgentScannersFlagEnabled(state)) {
    const error = new Error('Page not enabled');

    error.status = 404;

    throw error;
  }

  const organizationId = profile?.organization?.id;

  // Load scanners if not already loaded
  const scanners = agentScannersSelectors.scanners(state);
  const isFetching = agentScannersSelectors.isFetchingScanners(state);

  if (organizationId && scanners.length === 0 && !isFetching) {
    await dispatch(agentScannersActions.loadAgentScanners(organizationId));
  }
};

export default resolve;
